import styled from 'styled-components';

import { Meta, BodyCopy } from '@xingternal/typography';
import {
  spaceS,
  spaceL,
  spaceXL,
  xdlColorHoverSecondary,
  xdlColorHover,
  xdlColorText,
  cornerRadiusL,
} from '@xingternal/tokens';
import { Link } from '@xingternal/link';

export const StyledBodyCopy = styled(BodyCopy)`
  color: ${xdlColorText};
  margin: 0;
`;

export const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  padding: 0;

  &,
  &:hover,
  &:focus,
  &:active {
    border-radius: ${cornerRadiusL};
    text-decoration: none;
  }

  // this rule allows you only to apply styles on devices with hover capability
  @media (hover: hover) {
    &:hover {
      background-color: ${xdlColorHover};
    }
  }

  &:active {
    background-color: ${xdlColorHoverSecondary};
  }
`;

export const StyledContainer = styled.div`
  padding: ${spaceXL} ${spaceL} ${spaceL} ${spaceL};
`;

export const StyledContent = styled.div`
  padding: ${spaceS};
`;

export const StyledMetaNoMargin = styled(Meta)`
  margin: 0;
`;
